import { cn } from "@/utils/cn";

export const PlayIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("text-[rgba(102,112,133,1)]", className)}
    >
      <path
        d="M18.8952 13.3408C18.5708 14.6829 17.0377 15.6314 13.9714 17.5284C11.0071 19.362 9.52518 20.279 8.3307 19.9104C7.83688 19.7579 7.38697 19.4686 7.02413 19.0699C6.14648 18.1057 6.14648 16.2355 6.14648 12.4954C6.14648 8.75517 6.14648 6.88493 7.02413 5.92075C7.38697 5.52212 7.83688 5.23274 8.3307 5.08037C9.52518 4.71183 11.0071 5.62869 13.9714 7.46233C17.0377 9.3593 18.5708 10.3078 18.8952 11.6499C19.0291 12.2039 19.0291 12.7868 18.8952 13.3408Z"
        fill="currentColor"
      />
    </svg>
  );
};

PlayIcon.displayName = "PlayIcon";
